interface PlaceholderImageProps {
  label: string
  className?: string
  variant?: 'hero' | 'nature' | 'camp' | 'resort'
}

const gradients = {
  hero: 'from-green-800 via-green-600 to-emerald-500',
  nature: 'from-emerald-700 via-teal-600 to-green-500',
  camp: 'from-amber-600 via-orange-500 to-yellow-400',
  resort: 'from-slate-700 via-slate-500 to-gray-400',
}

// Simple SVG illustrations for each variant
const illustrations: Record<string, JSX.Element> = {
  hero: (
    <svg viewBox="0 0 200 120" className="w-32 h-20 opacity-30">
      <path d="M20 100 L60 40 L100 80 L140 30 L180 100 Z" fill="white" />
      <circle cx="150" cy="30" r="15" fill="white" />
      <path d="M0 100 L200 100 L200 120 L0 120 Z" fill="rgba(255,255,255,0.2)" />
      <path d="M70 100 L85 70 L90 80 L100 60 L110 80 L115 70 L130 100 Z" fill="rgba(255,255,255,0.3)" />
    </svg>
  ),
  nature: (
    <svg viewBox="0 0 200 120" className="w-32 h-20 opacity-30">
      <path d="M80 100 L100 30 L120 100 Z" fill="white" />
      <path d="M70 100 L95 50 L120 100 Z" fill="rgba(255,255,255,0.5)" />
      <path d="M60 100 L90 60 L120 100 Z" fill="rgba(255,255,255,0.3)" />
      <rect x="96" y="100" width="8" height="15" fill="rgba(255,255,255,0.4)" />
    </svg>
  ),
  camp: (
    <svg viewBox="0 0 200 120" className="w-32 h-20 opacity-30">
      <path d="M60 100 L100 30 L140 100 Z" fill="white" />
      <path d="M90 100 L100 60 L110 100 Z" fill="rgba(0,0,0,0.1)" />
      <path d="M20 100 L30 80 L40 100 Z" fill="rgba(255,255,255,0.5)" />
      <path d="M160 100 L170 75 L180 100 Z" fill="rgba(255,255,255,0.5)" />
    </svg>
  ),
  resort: (
    <svg viewBox="0 0 200 120" className="w-32 h-20 opacity-30">
      <rect x="50" y="50" width="100" height="50" rx="2" fill="white" />
      <rect x="60" y="60" width="20" height="15" rx="1" fill="rgba(0,0,0,0.1)" />
      <rect x="90" y="60" width="20" height="15" rx="1" fill="rgba(0,0,0,0.1)" />
      <rect x="120" y="60" width="20" height="15" rx="1" fill="rgba(0,0,0,0.1)" />
      <path d="M45 50 L100 25 L155 50 Z" fill="rgba(255,255,255,0.8)" />
    </svg>
  ),
}

export default function PlaceholderImage({
  label,
  className = '',
  variant = 'nature',
}: PlaceholderImageProps) {
  return (
    <div
      className={`bg-gradient-to-br ${gradients[variant]} flex flex-col items-center justify-center ${className}`}
    >
      {illustrations[variant]}
      <span className="text-white/60 text-xs mt-2 font-medium tracking-wide uppercase">
        {label}
      </span>
    </div>
  )
}
